import Calendar16 from '@carbon/icons-react/es/calendar/16';
import { Space } from 'antd';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { DateRange, getValueFromDateRange } from './types';

const SelectedRange = styled.span`
  color: var(--gray-50);
`;

export interface RangePickerTriggerProps {
  range: DateRange;
}

export const rangePickerTriggerDateFormat = 'DD MMM YY';

export const Trigger: FC<RangePickerTriggerProps> = ({ range }) => {
  const date = useMemo(
    () =>
      getValueFromDateRange(range).map((x) =>
        x.format(rangePickerTriggerDateFormat),
      ) as [string, string],
    [range],
  );

  const [startDate, endDate] = useMemo(() => date, [date]);

  return (
    <Button icon={<Calendar16 />} type="text" size="small">
      <Space size={4}>
        {startDate}-{endDate}
        <SelectedRange>({useTranslation(range.type)})</SelectedRange>
      </Space>
    </Button>
  );
};
